import request from '@service/request';
import config from '@config';
import { getAuthOptions } from '@service/utils.js';

const matchesPath = `${config.apiURL}/forecast-matches`;
const groupsPath = `${config.apiURL}/forecast-groups`;

export const fetchForecastMatchesByUser = (token, userId) =>
  request.get(matchesPath, { params: { userId }, ...getAuthOptions(token) });

export const patchForecastMatches = (
  token,
  matches,
  isWildcardMode = false,
  faseActivacion = null
) => {
  const params = {};
  if (isWildcardMode) {
    params.wildcardMode = true;
    if (faseActivacion) params.faseActivacion = faseActivacion;
  }
  const options = {
    ...getAuthOptions(token),
    params
  };
  return request.patch(matchesPath, matches, options);
};

export const fetchForecastGroupsByUser = (token, userId) =>
  request.get(groupsPath, { params: { userId }, ...getAuthOptions(token) });

export const patchForecastGroups = (token, groups) =>
  request.patch(groupsPath, groups, getAuthOptions(token));
